import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'banner3',
    },
    image: {
      className: 'banner3-image',
      children: 'https://imm.86links.com/assets/landing/banner/banner3.jpg',
    },
    textWrapper: {
      className: 'banner3-text-wrapper',
      children: [
        {
          name: 'Logo',
          className: 'banner3-logo',
          children:
            'https://imm.86links.com/assets/landing/images/%E7%BC%96%E7%BB%84%204%402x.png',
        },
        {
          name: '英文名称',
          className: 'banner3-name-en',
          children: 'Seeking Experience & Engineering Conference',
        },
        {
          name: '主题名称',
          className: 'banner3-slogan',
          children: '首届86links体验科技大会',
          texty: 'true',
        },
        {
          name: '描述文本',
          className: 'banner3-name',
          children: '探索极致用户体验与最佳工程实践探索',
        },
        {
          name: '时间地址',
          className: 'banner3-time',
          children: '2023.07.07 / 中国·上海',
        },
      ],
    },
  },
};
